import { BusinessOutlined } from '@mui/icons-material';
import { Avatar, Box, Button, capitalize, Chip, Typography } from '@mui/material';
import { capitalCase, paramCase } from 'change-case';
import { InfoBannerItem } from 'src/careflow/common/EditableCard';
import { WrappedOrganization } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Organization';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';

const FhirOrganizationBanner = ({
  organization,
  translate,
  isSystemOrg,
}: {
  organization: WrappedOrganization | null;
  translate: any;
  isSystemOrg: string | null;
}) => (
  <Box
    sx={[
      {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
      },
    ]}
  >
    <Box
      sx={{
        display: 'flex',
        width: 'auto',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar
        onClick={() => {}}
        variant="square"
        sx={[
          {
            width: 70,
            height: 70,
            '&:hover': {
              cursor: 'pointer',
            },
            borderRadius: 2,
          },
        ]}
      >
        <BusinessOutlined />
      </Avatar>
    </Box>

    <Box sx={{ top: -5, position: 'relative', ml: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Typography sx={{ marginRight: 1 }} variant="h5">
          {capitalize(organization?.name ?? '')}
        </Typography>

        <Chip
          size="small"
          label={capitalCase(
            organization?.active
              ? translate('details.general.active')
              : translate('details.general.inactive')
          )}
          color={(organization?.active && 'info') || 'error'}
        />

        {isSystemOrg && (
          <Button
            component="a"
            href={`${PATH_DASHBOARD.organization.edit(paramCase(isSystemOrg))}`}
            rel="noopener noreferrer"
            size="small"
            variant="contained"
            endIcon={<Iconify icon="fluent:open-12-filled" />}
            sx={{
              ml: 1,
              textTransform: 'none',
              borderRadius: 2,
              bgcolor: 'primary.main',
            }}
          >
            {translate('details.general.systemOrg')}
          </Button>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 1,
          flexWrap: 'wrap',
          width: '100%',
          gap: 0.7,
        }}
      >
        <InfoBannerItem label={translate('details.general.npi')} value={organization?.getNPI()} />
        <InfoBannerItem label={translate('details.general.type')} value={organization?.getType()} />
        <InfoBannerItem
          label={translate('details.general.phone')}
          value={organization?.getPhones()?.[0]}
        />
        <InfoBannerItem
          capitalize={false}
          label={translate('details.general.email')}
          value={organization?.getEmails()?.[0]}
        />
      </Box>
    </Box>
  </Box>
);

export default FhirOrganizationBanner;
